import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import LoadingSpinner from '@/components/LoadingSpinner';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Club Corners → HRMS SSO callback (CLB-391).
 * URL: /sso/callback?code=...
 */
const SsoCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { completeSsoLogin } = useAuth();
  const [message, setMessage] = useState('Signing you into HRMS…');

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      const code = searchParams.get('code')?.trim();
      if (!code) {
        toast.error('Missing SSO code. Please sign in with your password.');
        navigate('/login?ssoError=missing_code', { replace: true });
        return;
      }

      try {
        await completeSsoLogin(code);
        if (!cancelled) {
          setMessage('Redirecting…');
        }
      } catch (error: any) {
        if (cancelled) return;
        const detail =
          error?.response?.data?.message ||
          error?.message ||
          'SSO sign-in failed';
        toast.error(detail);
        navigate(`/login?ssoError=${encodeURIComponent('invalid_code')}`, {
          replace: true,
        });
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate, completeSsoLogin]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <LoadingSpinner />
      <p className="mt-4 text-sm text-gray-600">{message}</p>
    </div>
  );
};

export default SsoCallback;
